import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useProject } from "./ProjectContext";
export var ProjectView = function () {
    var project = useProject();
    return (_jsx("div", { className: "flex flex-1 items-center justify-center", children: _jsxs("div", { className: "flex flex-col items-center gap-2 rounded-lg border border-border p-4 text-tertiary", children: [_jsxs("span", { children: ["Viewing project ", project === null || project === void 0 ? void 0 : project.name] }), _jsx("span", { children: "Open or create a doc from the sidebar to get started" })] }) }));
};
